import {ChangeDetectionStrategy, Component, HostBinding} from '@angular/core';

@Component({
  selector: 'tisa-article-block-sponsor-bar',
  templateUrl: './article-block-sponsor-bar.component.html',
  styleUrls: ['article-block-sponsor-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ArticleBlockSponsorBarComponent {
  @HostBinding('class')
  readonly className = 'bg-black-500 grid justify-center items-center h-[40px]';
}
